// import { hiddenPages } from "constants"
// import { useLocation } from "react-router-dom"

// export const usePageLocation = () => {
//     const location = useLocation().pathname
//     const isVisible = !hiddenPages.includes(location)
//     return isVisible
// }
